// Recording Data Management
export function removeNewRecordingData(recordingUUID: string) {
  localStorage.removeItem(recordingUUID);
}

export function getRecordingToClean() {
  return localStorage.getItem("recordingToClean");
}

export function saveRecordingToClean(recordingId: string) {
  localStorage.setItem("recordingToClean", recordingId);
}

// Before recording data moved to IndexedDB, every save also wrote a {recordingUUID: <json>}
// entry directly to localStorage (see saveNewRecordingData, removed). Those entries are no
// longer written or read anywhere, but can still be sitting in a returning user's browser.
// localStorage keys aren't namespaced, so a raw recordingUUID key can't be told apart from
// unrelated app keys by name alone - only by shape: the value must parse as an object whose
// own recordingUUID field matches the key it's stored under, exactly how saveNewRecordingData
// used to write it.
export function cleanupLegacyRecordingLocalStorage(): void {
  const keysToRemove: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;

    const value = localStorage.getItem(key);
    if (!value) continue;

    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === "object" && parsed.recordingUUID === key) {
        keysToRemove.push(key);
      }
    } catch {
      // Not JSON, so not one of ours - leave it alone.
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
